import { Component, computed, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { DynamicComponent, Register } from '@xanadu/core';
import { SafeStyle } from '@angular/platform-browser';
import { StyleHelper } from '../../common/helper/style.helper';

@Component({
    selector: 'app-layout-column',
    templateUrl: './layout-column.component.html',
    styleUrls: ['./layout-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('layout-column')
export class LayoutColumnComponent extends DynamicComponent {
    private readonly styleHelper = inject(StyleHelper);

    style = computed<SafeStyle>(() => {
        const model = this.model();
        return model ? this.styleHelper.parse(model.style) : '';
    });

    columns = computed(() => {
        const model = this.model();
        return model ? model.columns : [];
    });
}
